import 'ol/ol.css';
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import TileWMS from 'ol/source/TileWMS';
//import WMTS from 'ol/source/WMTS';
//import WMTSTileGrid from 'ol/tilegrid/WMTS';
import {get as getProjection} from 'ol/proj';
import {getTopLeft, getWidth} from 'ol/extent';
import {defaults as defaultControls} from 'ol/control';
import MousePosition from 'ol/control/MousePosition';
import {createStringXY} from 'ol/coordinate';
import LayerSwitcher from 'ol/control';

var projection = getProjection('EPSG:4326');
var projectionExtent = projection.getExtent();
var size = getWidth(projectionExtent) / 256;
var resolutions = new Array(14);
var matrixIds = new Array(14);
for (var z = 0; z < 14; ++z) {
  // generate resolutions and matrixIds arrays for this WMTS
  resolutions[z] = size / Math.pow(2, z + 1);
//  matrixIds[z] ='EPSG:4326:' + z;
  matrixIds[z] = z;
}

var FLSource = new TileWMS({
    url: 'https://forgottenlives.ca/wms/',
    params: {'LAYERS': 'forgottenlives:Forgottenlives_Layered', 'TILED': true},
    serverType: 'qgis',
    });

//var FLSource = new WMTS({
//        url: 'https://forgottenlives.ca/wmts/',
//        layer: 'forgottenlives:Forgottenlives_Layered',
//        matrixSet: 'EPSG:4326',
//        format: 'image/png',
//        projection: projection,
//        tileGrid: new WMTSTileGrid({
//          origin: getTopLeft(projectionExtent),
//          resolutions: resolutions,
//          matrixIds: matrixIds,
//        }),
//        style: 'default',
//        wrapX: true,
//      })

var layers = [
  new TileLayer({source: new OSM()}),
  new TileLayer({source: FLSource})
  ];

var mousePositionControl = new MousePosition({
  coordinateFormat: createStringXY(4),
  projection: 'EPSG:4326',
  // comment the following two lines to have the mouse position
  // be placed within the map.
//  className: 'custom-mouse-position',
//  target: document.getElementById('mouse-position'),
  undefinedHTML: '&nbsp;'
});

var view = new View({
    projection: 'EPSG:4326',
    center: [-105.5, 52],
    zoom: 7
});

var map = new Map({
  controls: defaultControls().extend([mousePositionControl]),
  layers: layers,
  target: 'map-container',
  view: view
});

map.on('singleclick', function(evt) {
  document.getElementById('info').innerHTML = '';
  var viewResolution = /** @type {number} */ (view.getResolution());
  var url = FLSource.getFeatureInfoUrl(
    evt.coordinate, viewResolution, 'EPSG:4326',
    {'INFO_FORMAT': 'text/html'});
  if (url) {
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        document.getElementById('info').innerHTML = html;
      });
  }
});

map.on('pointermove', function(evt) {
  if (evt.dragging) {
    return;
  }
  var pixel = map.getEventPixel(evt.originalEvent);
  var hit = map.forEachLayerAtPixel(pixel, function() {
    return true;
  });
  map.getTargetElement().style.cursor = hit ? 'pointer' : '';
});
